import React from 'react';
import { motion } from 'framer-motion';
import HeroCarousel from '../components/Home/HeroCarousel';
import MechanicalServicesSection from '../components/Home/MechanicalServicesSection';
import TireSpecialSection from '../components/Home/TireSpecialSection';
import ServicesGrid from '../components/Home/ServicesGrid';
import ValuesSection from '../components/Home/ValuesSection';
import TestimonialsSection from '../components/Home/TestimonialsSection';

const HomePage: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <HeroCarousel />
      <MechanicalServicesSection />
      <TireSpecialSection />
      <ServicesGrid />
      <ValuesSection />
      <TestimonialsSection />
    </motion.div>
  );
};

export default HomePage;